import React from "react";
import { Link } from "react-router-dom";

// Shared by every Global M&S Sales tier page (Sales & Inventory, Marketing & Leads Generation,
// Marketing Performance) and Trim Mix Analysis - all four gate access behind linking a Nissan ID
// to a Google account the same way, via DashboardBannerContext.setBannerText.
export const GlobalMSSalesGoogleAccessBanner = () => (
  <>
    Access is linked to a Google ID. To associate your Nissan ID to Google, follow the steps on this{" "}
    <a href="http://accounts.google.com/signupwithoutgmail" target="_blank" rel="noopener noreferrer">
      link
    </a>{" "}
    and let us know{" "}
    {/* /global_ms_sales/pdf_page (the page this text originally pointed at) no longer exists - that
        guide moved to /faq/link_google_account (see GoogleConnectTileContent.tsx/App.tsx's own
        comments on that move) - linking there instead of the stale path. */}
    <Link to="/faq/link_google_account">here</Link> once done so we can quickly activate your access!
  </>
);
